import React, { useState } from 'react';
import Style from './SearchBar.module.css'

export default function SearchBar({onSearch}) {
  const {searchInput, button} = Style
  const [input, setInput] = useState('')
  const  handleInput = (e) => {
    setInput(e.target.value)
  }
  // acá va tu código
  return <div>
    <form
      onSubmit={(e) => {
      e.preventDefault();
      onSearch(input) 
      setInput('')}}
    >
      <input  type="text" placeholder='Busca tu ciudad' id='inputSearch' className={searchInput} onChange={handleInput} value={input }/>
      <input className={button} type="submit" value="Agregar"/>
    </form>
    
  </div>
};